const LOCAL_APP = process.env.REACT_APP_ENV === 'development'

// Helper method to load resources when embedding application
export default function getPublicAsset(assetName: string, defaultPath: string): string {
  return LOCAL_APP ? defaultPath : assetName
}
